import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CrmCampaignAnalytics from '../../views/crm/analytics/CrmCampaignAnalytics';
import CroAccounts from '../../views/crm/analytics/CroAccounts';
import CourseSourceAnalytics from '../../views/crm/analytics/CourseSourceAnalytics';
import RetainCallAnalytics from '../../views/crm/analytics/RetainCallAnalytics';
import LeadCourseAnalytics from '../../views/crm/analytics/LeadCourseAnalytics';
import CrmPaidAssessmentAnalytics from '../../views/crm/analytics/CrmPaidAssessmentAnalytics';
import OgaConversionAnalytics from '../../views/crm/analytics/OgaConversionAnalytics';
import CrmEvaluationAnalytics from '../../views/crm/analytics/CrmEvaluationAnalytics';
import CroPerfomanceAnalytics from '../../views/crd/Analytics/croPerfomanceAnalytics/croPerfomanceAnalytics';
import CroTaskAnalyticsClassroomNavigation from '../../views/crd/Analytics/CroTaskAnalyticsClassroom/CroTaskAnalyticsClassroomNavigation';
import CroIncomeForecastAnalyticsNavigation from '../../views/crd/Analytics/croIncomeForeCastAnalytics/CroIncomeForecastAnalyticsNavigation';
import CroAnalytics from '../../views/crd/Analytics/croAnalytics/CroAnalytics';
import CoursePerfomanceAnalytics from '../../views/crd/Analytics/coursePerfomanceAnalytics/CoursePerfomanceAnalytics';
import DataAnalyticsLanding from '../../views/dataAnalytics/DataAnalyticsLanding';
import DataAnalyticsDetailPage from '../../views/dataAnalytics/pages/DataAnalyticsDetailPage';
import { dataAnalyticsTitlesAndPath } from '../../views/dataAnalytics/utils/routeTitleConnection';

const AnalyticsRouter = () => {
  return (
    <Routes>
      <Route path="crm-campaign-analytics" element={<CrmCampaignAnalytics />} />
      {/* <Route path="cro-analytics" element={<CroAnalytics />} /> */}
      <Route path="/cro-accounts" element={<CroAccounts />} />
      <Route path="/course-source-analytics" element={<CourseSourceAnalytics />} />
      <Route path="/retain-call-analytics" element={<RetainCallAnalytics />} />
      <Route path="/lead-course-analytics" element={<LeadCourseAnalytics />} />

      <Route path="crm-paid-assessment-analytics" element={<CrmPaidAssessmentAnalytics />} />

      <Route path="crm-oga-conversion-analytics" element={<OgaConversionAnalytics />} />

      <Route path="crm-evaluation-analytics" element={<CrmEvaluationAnalytics />} />
      {/* NEW ANALYTICS ROUTES */}
      <Route path="cro-perfomance-analytics" element={<CroPerfomanceAnalytics />} />
      <Route path="cro-task-analytics-classroom" element={<CroTaskAnalyticsClassroomNavigation />} />
      <Route path="cro-income-forecast-analytics" element={<CroIncomeForecastAnalyticsNavigation />} />
      {/* Cro Analytics */}
      <Route path="cro-analytics" element={<CroAnalytics />} />
      {/* Course Perfomance Analytics */}
      <Route path="course-perfomance-analytics" element={<CoursePerfomanceAnalytics />} />

      {/* Data Analytics  */}
      <Route path="data-analytics">
        <Route index element={<DataAnalyticsLanding />} />
        <Route path={dataAnalyticsTitlesAndPath.ACTIVE_TUTORS} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.TRAINER_UNMAPPED} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.NEWLY_ASSIGNED_TUTORS} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.ACTIVE_TUTORS_SUBJECT} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.TP_PAID_TUTORS} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.STUDENT_TUTOR_RATIO} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.TUTOR_CHANGE_DATA} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.INACTIVE_TUTORS} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.LAST_ASSIGNED_TP} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.RESIGNED_TUTORS} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.COURSE_ENROLLMENT} element={<DataAnalyticsDetailPage />} />
        <Route path={dataAnalyticsTitlesAndPath.ACTIVE_STUDENTS} element={<DataAnalyticsDetailPage />} />
      </Route>
    </Routes>
  );
};

export default AnalyticsRouter;
